import axios from "axios";
import { isBrowser } from "@/helpers/isBrowser";
import { NEXT_PUBLIC_CART_SERVICE_BASE_URL } from "@/libs/constants/auth";
import { AppDispatch } from "@/redux/store";
import { updateTotalCartItemCount } from "@/redux/slice/cart/slice";

type FetchTotalCartItemCountInput = {
  dispatch: AppDispatch;
  authToken: string;
};

const fetchTotalCartItemCount = async ({ dispatch, authToken }: FetchTotalCartItemCountInput) => {
  if (isBrowser()) {
    const mobileNumber = localStorage.getItem("mobile_num") || "";

    if (mobileNumber) {
      const cartCountResponse: Record<string, any> = await axios.get(
        `${NEXT_PUBLIC_CART_SERVICE_BASE_URL}/public/user-cart`,
        {
          headers: {
            mobilenumber: mobileNumber,
            Authorization: authToken,
          },
        }
      );

      if (cartCountResponse?.data?.patientId) {
        dispatch(updateTotalCartItemCount(cartCountResponse?.data?.totalItemsCount || 0));
      }
    }
  }
};

export default fetchTotalCartItemCount;
